import { createContext } from 'react'

type State = {
  accessToken: string | null
  setAuthToken: (token: string | null) => void
  updateRefreshToken: (token: string | null) => void
}

export const AuthContext = createContext<State | undefined>(undefined)
